<div class="flex flex-1 flex-col justify-center gap-7 px-10 py-16">
  <p class="m-0 text-sm font-bold uppercase tracking-wide">Your Quick Brief</p>
  <div class="max-w-md rounded-xl bg-card p-5 text-card-foreground shadow-xl">
    <div class="flex items-center gap-3 border-b border-border pb-4">
      @if (brief.brandLogo()) {
        <img [src]="brief.imageSrc(brief.brandLogo())" alt="" class="size-12 rounded-lg object-cover" />
      } @else {
        <span class="flex size-12 items-center justify-center rounded-lg bg-brand-studio text-xl font-black text-white" aria-hidden="true">{{ brief.brandName().charAt(0) }}</span>
      }
      <div>
        <p class="m-0 text-xl font-bold">{{ brief.brandName() }}</p>
        <p class="m-0 text-base font-semibold text-muted-foreground">{{ brief.domain() }}</p>
      </div>
    </div>
    <dl class="m-0">
      <div class="flex items-center justify-between gap-4 border-b border-border py-3">
        <dt class="text-base font-bold text-muted-foreground">Promoting</dt>
        <dd class="m-0 text-right text-lg font-bold">{{ brief.summaryPromoting() || '—' }}</dd>
      </div>
      <div class="flex items-center justify-between gap-4 border-b border-border py-3">
        <dt class="text-base font-bold text-muted-foreground">Content</dt>
        <dd class="m-0 text-right text-lg font-bold">{{ brief.summaryContent() || '—' }}</dd>
      </div>
      <div class="flex items-center justify-between gap-4 py-3">
        <dt class="text-base font-bold text-muted-foreground">Channels</dt>
        <dd class="m-0 text-right text-lg font-bold" [class]="brief.format() === 'ugc' ? 'text-muted-foreground' : ''">{{ brief.summaryChannels() || '—' }}</dd>
      </div>
    </dl>
  </div>
  <p class="m-0 max-w-md text-xl font-semibold">SHOUT AI writes the rest: concepts, deliverables and creator requirements.</p>
</div>
